// Smooth-scroll to an in-page anchor, using the Lenis instance when available.
export const scrollToId = (id) => {
  const target = document.querySelector(id);
  if (!target) return;
  const lenis = window.__lenis;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(target, { offset: -96, duration: 1.1 });
  } else {
    const top = target.getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

export const handleAnchorClick = (e, href) => {
  if (href && href.startsWith("#")) {
    e.preventDefault();
    scrollToId(href);
  }
};
